export const SUBSCRIBE_TYPE = {
  /** 订阅 */
  SUBSCRIBE: 1,
  /** 取消订阅 */
  UNSUBSCRIBE: 0,
} as const;

export const SUBSCRIBE_FAILED_MSG = '订阅失败，请重新尝试。';
export const UN_SUBSCRIBE_FAILED_MSG = '取消失败，请重新尝试。';
export const CANCEL_SUBSCRIBE_SUC_MSG = '已取消订阅';

export const APP_ID = 1; // PUSH开关接口所需的appid，手炒固定为1
